import { createSlice } from '@reduxjs/toolkit';
import { FULLFILLED } from '@root/constants';
import { AUTH_LOGIN, AUTH_LOGOUT } from '@root/store/action-types';
import { USER_PROFILE } from '@root/store/action-types/userProfile';


const INITIAL_STATE: IAuthEntities = {
  data: null,
  givenEmailForPasswordRecovery: {
     email:"test@gmail.com",
  },
  avatar: '',
  profile: {}
};

export const authEntitySlice = createSlice({
  name: 'auth',
  initialState: INITIAL_STATE,
  reducers: {
    resetAuthData: (state) => {
      state.data = null;
    },
    setAuthData: (state, action) => {
      state.data = action.payload;
    },
    updatePasswordRecoverEmail: (state, action) => {
      state.givenEmailForPasswordRecovery = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(`${AUTH_LOGIN}${FULLFILLED}`, (state, action: any) => {
      const { token, ...rest } = action.payload;
      state.data = rest?.user;
    });
    builder.addCase(`${AUTH_LOGOUT}${FULLFILLED}`, (state) => {
      state.data = null;
    });
    builder.addCase(`${USER_PROFILE}${FULLFILLED}`, (state, action: any) => {
      state.data = action?.payload;
    });
    // builder.addCase(`${GET_PROFILE}${FULLFILLED}`, (state, action: any) => {
    //   state.profile = action?.payload;
    // });
  },
});

export const { resetAuthData, setAuthData, updatePasswordRecoverEmail } = authEntitySlice.actions;

export const authEntityReducer = authEntitySlice.reducer;
